import cl from './TermsAndConditionsPage.module.css'


const TermsAndConditionsPage = () => {
  return (
    <div className={cl.container}>
      <p>
        The website is still in development, what kind of terms and conditions did you expect :)?<br/>
      Although they are deffinitely to be added, so why not checking a little bit later?</p>
    </div>
  );
};

export default TermsAndConditionsPage;
